export default {
  en: {
    back: 'Back',
    general: 'General',
    agent: 'Agent',
    rateCode: 'Rate Code',
    promotion: 'Promotion',
    supplement: 'Supplement',
    transfer: 'Transfer',
    backToContractList: 'Back to contract list',
    previewContract: 'Preview Contract',
    saveDraft: 'Save Draft',
    createContractSuccessTitle: 'Success',
    createContractSuccessMessage: 'Create Contract Success.'
  },
  th: {
    back: 'กลับ',
    general: 'ทั่วไป',
    agent: 'ตัวแทน',
    rateCode: 'ประเภทเรท',
    promotion: 'โปรโมชั่น',
    supplement: 'รายการเพิ่มเติม',
    transfer: 'รถรับส่ง',
    backToContractList: 'Back to contract list',
    previewContract: 'ดูตัวอย่างสัญญา',
    saveDraft: 'บันทึกฉบับร่าง',
    createContractSuccessTitle: 'สำเร็จ',
    createContractSuccessMessage: 'สร้างสัญญาสำเร็จ.'
  }
}
